import React from 'react';
import { Header, Icon, Popup } from 'semantic-ui-react';
import _isString from 'lodash/isString';
import { EnhancedLabelsPropType } from './HoursOfOperation.PropTypes';
import StatusLabel from './components/StatusLabel';
import { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../modules/analytics/components/Event';
import FadeReveal from '../../modules/animations/components/Reveal/variants/FadeReveal/FadeReveal';
import { GoogleAnalytics } from '../../services/analytics';
import { HourOfOperationPropType } from '../../services/proptypes';
var defaultProps = {
  timezone: null,
  label: 'See hours',
  secondaryLabel: '',
  position: 'bottom left',
  header: '',
  enhancedLabels: {}
};
export default function HoursOfOperationDailyWithPopup(_ref) {
  var displayOpenClosedStatus = _ref.displayOpenClosedStatus,
    timezone = _ref.timezone,
    hours = _ref.hours,
    children = _ref.children,
    label = _ref.label,
    secondaryLabel = _ref.secondaryLabel,
    position = _ref.position,
    header = _ref.header,
    enhancedLabels = _ref.enhancedLabels;
  var visibleFirstDay;
  if (displayOpenClosedStatus && timezone) {
    visibleFirstDay = /*#__PURE__*/React.createElement("div", {
      className: "hoo-withpopup-first"
    }, /*#__PURE__*/React.createElement(StatusLabel, {
      hours: hours,
      timezone: timezone,
      enhancedLabels: enhancedLabels
    }), secondaryLabel, /*#__PURE__*/React.createElement(Icon, {
      name: "caret down"
    }));
  } else {
    visibleFirstDay = /*#__PURE__*/React.createElement("div", {
      className: "hoo-withpopup-first"
    }, /*#__PURE__*/React.createElement("header", {
      className: "h4"
    }, label), /*#__PURE__*/React.createElement("p", {
      className: "hoo-hours-paragraph"
    }, secondaryLabel), /*#__PURE__*/React.createElement(Icon, {
      name: "caret down"
    }));
  }
  function onOpen() {
    GoogleAnalytics.event(EVENT_CATEGORIES.HOURS_OF_OPERATION_EVENT_CATEGORY, EVENT_ACTIONS.HOURS_OF_OPERATION_SHOW_EVENT_ACTION);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, header && (_isString(header) ? /*#__PURE__*/React.createElement(Header, {
    as: "header",
    className: "h2"
  }, header) : header), /*#__PURE__*/React.createElement(Popup, {
    className: "hoo-popup",
    position: position,
    trigger: visibleFirstDay,
    content: /*#__PURE__*/React.createElement(FadeReveal, {
      triggerOnce: true
    }, children),
    basic: true,
    on: "click",
    onOpen: onOpen
  }));
}
HoursOfOperationDailyWithPopup.defaultProps = defaultProps;